import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useState } from "react";

import { Link } from "react-router-dom";
import { useEffect } from "react";
import { fetchAllRecipes } from "../firebase/fireStoreServices";

export default function RecipesPage() {
  const [category, setCategory] = useState("All");

  // Fetching Recipe data from database through service layer i.e. firebase/fireStoreServices
  const [recipesData, SetRecipesData] = useState(null);
  useEffect(() => {
    const loadAllRecipes = async () => {
      const recipesData = await fetchAllRecipes();
      SetRecipesData(recipesData);
    };
    loadAllRecipes();
  }, []);

  const filteredRecipes =
    category === "All"
      ? recipesData || []
      : (recipesData || []).filter((recipe) => recipe.category === category);

  return (
    <Container maxWidth="lg">
      <Box sx={{ textAlign: "center", my: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="primary">
          Explore Our Recipes 🍽️
        </Typography>

        <FormControl sx={{ mb: 3, minWidth: 300, mt: 2 }}>
          <InputLabel>Filter by Category</InputLabel>
          <Select
            value={category}
            label="Filter by Category"
            onChange={(e) => setCategory(e.target.value)}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Main Course">Main Course</MenuItem>
            <MenuItem value="Dessert">Dessert</MenuItem>
            <MenuItem value="Starter">Starter</MenuItem>
            <MenuItem value="Snacks">Snakcs</MenuItem>
            <MenuItem value="Soup">Soup</MenuItem>
            <MenuItem value="Drinks">Drinks</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Grid container spacing={3}>
        {filteredRecipes.length === 0 ? (
          <Typography variant="h6" textAlign="center" mt={5}>
            No recipes found!
          </Typography>
        ) : (
          filteredRecipes.map((recipe, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  borderRadius: 5,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 15,
                  },
                }}
              >
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="200"
                    image={recipe.image}
                    alt={recipe.title}
                    loading="lazy"
                  />
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      color="secondary"
                    >
                      {recipe.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {recipe.description}
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ mt: 2 }}
                      color="primary"
                      fullWidth
                      component={Link}
                      to={`/recipe/${recipe.id}`}
                    >
                      View Recipe
                    </Button>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
}
